<template>
  <div class="stopwatch-container"
       @click="onTouch"
  >
    <div class="stopwatch-time-container">
      <button class="reset-timer" @click.stop="onOpenResetStopwatch"></button>
      <div class="time">{{formatStopwatchTime}}</div>
      <button class="stop-timer" :class="{active: this.stopwatchState ==='pause'}" @click.stop="toggleStopwatch"></button>
    </div>
    <div class="detail-timer-info">
      <div class="detail-container total" v-show="studyInfoSetting?.todayStudyTime">
        <div class="detail-title">{{ $t('camstudy.stopwatch.todayStudyTime') }}</div>
        <div class="detail-content">{{ formatTodayStudyTime }}</div>
      </div>
      <div class="detail-container target" v-show="studyInfoSetting?.targetStudyTime">
        <div class="detail-title">{{ $t('camstudy.stopwatch.targetStudyTime') }}</div>
        <div class="detail-content">{{formatTargetStudyTime}}</div>
      </div>
      <div class="detail-container total" v-show="studyInfoSetting?.totalStudyTime">
        <div class="detail-title">{{ $t('camstudy.stopwatch.totalStudyTime') }}</div>
        <div class="detail-content">{{ formatTotalStudyTime }}</div>
      </div>
      <div class="detail-container" v-show="studyInfoSetting?.remainDays">
        <div class="detail-title">{{ $t('camstudy.stopwatch.myDDay') }}</div>
        <div class="detail-content">{{ formatDDayTime }}</div>
      </div>
      <div class="detail-container" v-show="studyInfoSetting?.studyDays">
        <div class="detail-title">{{ $t('camstudy.stopwatch.studyPeriod') }}</div>
        <div class="detail-content">{{formatStudyRemainTime}}</div>
      </div>
    </div>
    <GrmCamstudyOptionModal
        v-if="isOpenStopWatchOption"
        :title="$t('camstudy.stopwatch.options.reset.selectTitle')"
        :list="stopWatchResetType"
        name="stop-watch-reset-type"
        value="timer-reset"
        @onCloseOption="onCloseStopWatchResetType"
        @onNextAct="onReqResetStopWatch"
    />
    <GrmCamstudyOptionModal
        v-if="isOpenAttendOption"
        :title="$t('camstudy.stopwatch.options.attendance.selectTitle')"
        :list="attendCheckType"
        name="attend-check-type"
        value="attend"
        @onCloseOption="onCloseAttendOption"
        @onNextAct="onReqAttendOption"
    />
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import GrmCamstudyOptionModal from "@/components/Common/camstudyOptionModal/GrmCamstudyOptionModal.vue";

export default {
  name: 'CallStopWatch',
  components: {GrmCamstudyOptionModal},
  data() {
    return {
      isOpenStopWatchOption: false,
      isOpenAttendOption: false,
    }
  },
  computed: {
    ...mapGetters('user', ['me']),
    ...mapGetters('camstudy', [
        'getUserStopwatch',
        'getCamStudyUser',
        'getUserStudyData',
        'studyInfoSetting',
        'camStudy',
        'mainDDay',
        'isAttend'
    ]),
    stopwatch() {
      return this.getUserStopwatch(this.me.userId)
    },
    stopwatchState() {
      return this.stopwatch?.state || 'pause'
    },
    studyData() {
      return this.getUserStudyData(this.me.userId)
    },
    camStudyUser() {
      return this.getCamStudyUser(this.me.userId)
    },
    formatStopwatchTime() {
      return this.formatTime(this.stopwatch?.time || 0)
    },
    formatTodayStudyTime() {
      return this.formatTime( this.studyData?.time || 0)
    },
    formatTotalStudyTime() {
      return this.formatTime( this.camStudyUser?.time || 0)
    },
    formatTargetStudyTime() {
      return this.formatTime(this.camStudyUser?.targetDayTime || 0)
    },
    formatStudyRemainTime() {
      const targetDate = new Date(this.camStudy.endResvDate);
      const currentDate = new Date()

      const targetDay = new Date(targetDate.getFullYear(), targetDate.getMonth(), targetDate.getDate());
      const currentDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());

      const diff = targetDay - currentDay;

      return `D- ${Math.ceil(diff / 86400000)}`
    },
    formatDDayTime() {
      if(!this.mainDDay) {
        return this.$t('camstudy.stopwatch.none')
      }

      const targetDate = new Date(this.mainDDay.day);
      const currentDate = new Date()

      const targetDay = new Date(targetDate.getFullYear(), targetDate.getMonth(), targetDate.getDate());
      const currentDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());

      const diff = targetDay - currentDay;
      const diffDays = Math.ceil(diff / 86400000);

      return diffDays < 0 ? `D+ ${Math.abs(diffDays)}` : (diffDays === 0 ? 'D-Day' : `D- ${diffDays}`);
    },
    stopWatchResetType() {
      return [
        {
          value: 'timer-reset',
          name: this.$t('camstudy.stopwatch.options.reset.timerResetName'),
          message: this.$t('camstudy.stopwatch.options.reset.timerResetMessage'),
        },
        {
          value: 'history-reset',
          name: this.$t('camstudy.stopwatch.options.reset.historyResetName'),
          message: this.$t('camstudy.stopwatch.options.reset.historyResetMessage'),
        }
      ];
    },
    attendCheckType() {
      return [
        {
          value: 'attend',
          name: this.$t('camstudy.stopwatch.options.attendance.attendName'),
          message: this.$t('camstudy.stopwatch.options.attendance.attendMessage'),
        },
        {
          value: 'stopwatch',
          name: this.$t('camstudy.stopwatch.options.attendance.stopwatchName'),
          message: this.$t('camstudy.stopwatch.options.attendance.stopwatchMessage'),
        }
      ];
    }
  },
  created() {
  },
  methods:{
    ...mapActions('camstudy', [
        'changeStopwatchState',
        'resetStopwatch',
        'createTodayCamStudyUserData',
        'isAttendCheck',
        'setAttendCheck',
        'resetAttendCheck'
    ]),
    ...mapActions('call', ['toggleConnectionStats']),
    ...mapActions('common', ['closeControlMenu']),
    formatTime(seconds) {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const secs = seconds % 60;

        const paddedHours = hours.toString().padStart(2, '0');
        const paddedMinutes = minutes.toString().padStart(2, '0');
        const paddedSeconds = secs.toString().padStart(2, '0');

        return `${paddedHours}:${paddedMinutes}:${paddedSeconds}`;
    },
    async toggleStopwatch() {
      if(!this.me) return
      const studyData = this.getUserStudyData(this.me.userId)

      if(!studyData) {
        this.$camsAlert({
          title: this.$t('camstudy.stopwatch.attendanceCheckTitle'),
          text: this.$t('camstudy.stopwatch.attendanceCheckText'),
          ok: () => {
            this.createTodayCamStudyUserData()
          }
        })
        return
      }
      const attendCheck = await this.isAttendCheck()
      if(this.stopwatchState !=='start'
          && !this.isAttend(this.me.userId)
          && !attendCheck
      ) {
        await this.setAttendCheck()
        this.isOpenAttendOption = true
        this.closeControlMenu();
        return
      }
      clearTimeout(this._toggleDebounce)
      this._toggleDebounce = setTimeout(() => {
        this.changeStopwatchState(this.stopwatchState !== 'start' ? 'start' : 'pause')
      }, 200)
    },
    onOpenResetStopwatch() {
      if(!this.me) return
      this.closeControlMenu();
      this.isOpenStopWatchOption = true;
    },

    onTouch (e) {
      const {target, clientX, clientY} = e;

      const rect = target.getBoundingClientRect();
      let tWidth = rect.width / 4;
      let tHeight = rect.height / 2;

      let leftRange = {
        x:rect.x, x1:rect.x+tWidth,
        y:rect.y+tHeight, y1:rect.y+rect.height
      };
      let rightRange = {
        x:rect.x+(tWidth*3), x1:rect.x+rect.width,
        y:rect.y+tHeight, y1:rect.y+rect.height
      };

      let touchIndex = [leftRange, rightRange].findIndex(range => {
        if(
            clientX >= range.x && clientX <= range.x1
            && clientY >= range.y && clientY <= range.y1
        ){
          return true;
        }
      });
      if(touchIndex < 0) return;

      const data = this._show_conn = this._show_conn || {
        touchIndex: -1,
        last: 0,
        cnt: 0,
      };
      const now = Date.now();
      if(now - data.last > 2000){
        data.cnt = 0;
      }
      if(touchIndex === data.touchIndex){
        data.cnt = 0;
      }

      data.touchIndex = touchIndex;
      data.last = now;
      data.cnt++;
      if(data.cnt >= 4){
        this.toggleConnectionStats({
          window: e.shiftKey || e.altKey
        });
      }
    },
    onCloseStopWatchResetType(){
      this.isOpenStopWatchOption = false;
    },
    onReqResetStopWatch(type){
      this.isOpenStopWatchOption = false;
      const resetData = type === 'history-reset'

      this.$camsAlert({
        title: this.$t(`camstudy.stopwatch.${resetData ? 'resetDataTitle' : 'resetTitle'}`),
        text: this.$t(`camstudy.stopwatch.${resetData ? 'resetDataText' : 'resetText'}`),
        ok: async () => {
          const isStart = this.stopwatchState === 'start'

          await this.resetStopwatch(resetData)
          if(isStart) {
            await this.changeStopwatchState('start')
          }
        }
      })
    },
    onCloseAttendOption(){
      this.isOpenAttendOption = false;
      this.resetAttendCheck()
    },
    onReqAttendOption(type){
      this.isOpenAttendOption = false;

      if(type === 'attend') {
        this.createTodayCamStudyUserData()
      } else {
        this.changeStopwatchState(this.stopwatchState !== 'start' ? 'start' : 'pause')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.stopwatch-container{
  display: flex;
  color: white;
  background: #141414;
  line-height: 1.5;

  @media(orientation: portrait) {
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 156px;
    padding-top: 40px;

    .stopwatch-time-container{
      .time {
        width: 180px;
        font-size: 44px;
        line-height: 100%;
      }
    }
  }

  @media(orientation: landscape) {
    padding: 20px;
    justify-content: center;
    gap: 12px;

    .stopwatch-time-container{
      .time {
        width: 170px;
        font-size: 40px;
        line-height: 150%;
      }
    }
  }

  .stopwatch-time-container{
    display: flex;
    align-items: center;
    gap: 10px;

    .reset-timer, .stop-timer{
      width: 32px;
      height: 32px;
    }

    .reset-timer {
      background: url("~@/assets/images/camstudy/stopwatch_reset_white.svg") no-repeat center / 100% auto;
    }

    .stop-timer {
      background: url("~@/assets/images/camstudy/stopwatch_pause_white.svg") no-repeat center / 100% auto;

      &.active{
        background: url("~@/assets/images/camstudy/stopwatch_pass_white.svg") no-repeat center / 100% auto;
      }
    }
  }
  .detail-timer-info{
    display: flex;
    max-width: 360px;
    justify-content: center;
    gap: 12px;
    margin-top: 14px;

    .detail-container{
      text-align: center;

      .detail-title{
        font-size: 10px;
        line-height: 150%;
        text-wrap: nowrap;
      }
      .detail-content{
        font-weight: 700;
        font-size: 12px;
        line-height: 150%;
      }
    }
  }
}
</style>